var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSignUp01 = function SvgSignUp01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg1",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g1",
    transform: "translate(0 -1.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "M29.2 18.3c-.8 0-1.4.6-1.4 1.4s.6 1.4 1.4 1.4 1.4-.6 1.4-1.4-.6-1.4-1.4-1.4m-1.1-1.4c2.2 0 3.9 1.7 3.9 3.9s-1.8 3.9-3.9 3.9c-.5 0-1-.1-1.4-.2l-2.1 2.1h-1.4V28h-1.4v1.4h-2.3V27l4.8-4.8c-.1-.5-.2-.9-.2-1.4.1-2.2 1.8-3.9 4-3.9M13.2 0h.1c5.1 0 6 3.6 5.9 5-.1 1.1-.4 2.6-.4 2.6s.5.2.5 1.2c-.2 2.5-1.2 1.4-1.4 2.5-.4 2.1-1.2 2.2-1.5 3-.1.2-.1.4-.1.6 0 2.4 1.2 3.5 4.8 4.8.8.3 1.5.6 2.1.8v.2c0 .4 0 .7.1 1.1l-4.7 4.7v2.7H0v-6c0-.9 1.6-2.3 5.3-3.6s4.8-2.4 4.8-4.8c0-.3 0-.5-.1-.6-.3-.7-1.1-.8-1.5-3-.2-1.1-1.2 0-1.4-2.5 0-1 .5-1.2.5-1.2S7.4 6.1 7.3 5c-.1-1.4.8-5 5.9-5",
    transform: "translate(0 1.3)"
  }))));
};
export { SvgSignUp01 as ReactComponent };
export default __webpack_public_path__ + "assets/Sign-Up-01.2c76561280462fee0fd4fa71f6709935.svg";